export default __webpack_public_path__ + "static/media/usability-test-learnings.9a6c58c1.svg";